import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const requestInquiry = (source = "contact", subject = "") => {
  window.dispatchEvent(
    new CustomEvent("inquiry:open", { detail: { source, subject } })
  );
  const target = document.getElementById("contact");
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -20, duration: 1.4 });
  } else if (target) {
    target.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToId = (id) => {
  const target = document.getElementById(id);
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -80, duration: 1.4 });
  } else if (target) {
    target.scrollIntoView({ behavior: "smooth" });
  }
};

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-medium text-crimson ${className}`}
  >
    <span className="w-6 h-px bg-crimson" />
    {children}
  </span>
);

export const CTAButton = ({
  children,
  onClick,
  variant = "primary",
  className = "",
  testid,
}) => {
  const base =
    "group inline-flex items-center gap-3 px-8 py-4 text-sm uppercase tracking-[0.15em] font-medium transition-all duration-300";
  const styles =
    variant === "primary"
      ? "bg-crimson text-white hover:bg-crimson-dark"
      : variant === "dark"
      ? "bg-charcoal text-white hover:bg-black"
      : "border border-charcoal/25 text-charcoal hover:border-crimson hover:text-crimson";
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      className={`${base} ${styles} ${className}`}
    >
      {children}
      <ArrowUpRight
        size={16}
        className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
      />
    </button>
  );
};
